"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContractStats = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
require("./style.sass");
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var ContractStats = function ContractStats(_ref) {
  var title = _ref.title,
    description = _ref.description,
    isLoading = _ref.isLoading;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "contract-stats"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'contract-title'
  }, isLoading ? /*#__PURE__*/_react.default.createElement("span", {
    style: {
      display: 'block',
      width: 30
    }
  }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, null)) : description), /*#__PURE__*/_react.default.createElement("span", {
    className: 'contract-description'
  }, title));
};
exports.ContractStats = ContractStats;
ContractStats.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  isLoading: _propTypes.default.bool.isRequired
};